import styled from "styled-components";

export const Page = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  .side {
    padding-top: 30px;
    display: flex;
    position: fixed;
    flex-direction:column;
    align-items: center;
    width: 327px;
    min-width: 327px;
    height: 100vh;
    background-color: ${({ theme }) => theme.colors.secondary10};
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
    .logo{
      width: 0px;
    }
    h1{
      font-size: 20px;
      display: flex;
      align-items: center;
      color: ${({ theme }) => theme.colors.secondary100};
      svg{
         margin-left: 5px;
      }
    }
    ul{
      width: 100%;
      margin-top: 20px;
      padding: 0px 25px;
      li{
        cursor: pointer;
        margin: 8px 0px;
        font-size: 16px;
        font-weight: 500;
        display: flex;
        align-items: center;
        background-color: ${({ theme}) => theme.colors.secondary10};
        color: ${({ theme}) => theme.colors.secondary100};
        padding: 14px;
        border-radius: 8px;
        transition:  .4s;
        border: 1px solid ${({ theme}) => theme.colors.secondary10};
        span{
          margin-left: 13px;
        }
        svg{
          width: 24px;
          height: 24px;
        }
        &:hover{
          border: 1px solid ${({ theme}) => theme.colors.primary};
        }
      }
      .active{
        background-color: ${({ theme}) => theme.colors.primary};
        color: ${({ theme}) => theme.colors.secondary10};
        padding: 14px;
        border-radius: 8px;
      }

    }
  }

  .main {
    width: 100%;
    height: 100%;
    padding-left: 327px;
    .header {
      height: 67px;
      width: 100%;
    }
    .content{
     
    }
  }
`;
